import {Stack, Typography} from '@mui/material';
import {ProjectContext} from '@context/ProjectContext';
import {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import NetworkIcon from '@icons/NetworkIcon';

export default function NetworkButton(props: any) {
	const {t} = useTranslation();
	const {shahadat} = useContext(ProjectContext);
	const isActive = !!props['aria-selected'];

	return (
		<Link to="/network" {...props}>
			<Stack direction="column" alignItems="center" spacing={0.5}>
				<NetworkIcon active={isActive}/>
				<Typography fontSize={12} sx={{color: shahadat && isActive ? '#000' : undefined}}>
					{t('network')}
				</Typography>
			</Stack>
		</Link>
	);
}
